<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyWinery')"
           :delete-row-function="(rows) => deleteRow('deleteWineries', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';
import Editor from './detail-row/WineryEditor';
import CommonBoardItems from '../CommonBoardItems';

Vue.component(config.detailRowComponentName, Editor);

export default {
  name: 'BoardWinery',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/winery/BoardWinery.vue